import F84Game from "../Game";

export default class LottieUtils {
	/*
	 * Unloads a lottie animation, removes the canvas, and clears the stored texture from Phaser's texture manager
	 */
	public static unloadAnimation(key: string): void {
		console.log("Unload " + key);
		const lottie: any = (<any>window).lottie;
		const animations: Array<any> = lottie.getRegisteredAnimations();
		const animation: any = animations.find((animation) => animation.key == key);
		if (animation) {
			animation.destroy();
		}
		lottie.destroy(key);
		if (F84Game.Instance.textures.exists(key)) {
			F84Game.Instance.textures.remove(key);
		}
		if (F84Game.Instance.cache.json.exists(key)) {
			F84Game.Instance.cache.json.remove(key);
		}
	}

	public static unloadAnimations(keys: string[]): void {
		for (const key of keys) {
			LottieUtils.unloadAnimation(key);
		}
	}
}
